import { useFormikContext } from 'formik';
import { AlloyButton, DeleteIcon } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { KEY_ICON_SIZE_LARGE, KEY_ICON_SIZE_SMALL } from '../constants';

const DeleteAction = ({ item, deleteInvalidItem }) => {
  const { setValues } = useFormikContext();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const iconSize = !isLG ? KEY_ICON_SIZE_LARGE : KEY_ICON_SIZE_SMALL;
  const deleteItemAndSet = () => {
    deleteInvalidItem(item, setValues);
  };
  return (
    <AlloyButton
      buttonType="ghost"
      icon={<DeleteIcon width={iconSize} height={iconSize} />}
      iconPosition="end"
      size="large"
      className="p-0"
      onClick={deleteItemAndSet}
    />
  );
};

export default DeleteAction;
DeleteAction.propTypes = {
  item: PropTypes.shape({
    itemNumber: PropTypes.string,
    partNumber: PropTypes.string,
    quantity: PropTypes.string,
    assetId: PropTypes.string
  }),
  deleteInvalidItem: PropTypes.func
};
